import {Route, Routes} from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Catalog from "./pages/Catalog";
import './App.css';
import ScrollToTop from "./pages/ScrollTop";

function App() {
  return (
      <div  style={{minWidth :"380px"}}>
          <ScrollToTop />
          <Routes>
              <Route path={"/"} element={<Home />} />
              <Route path={"/catalog"} element={<Catalog />} />
              <Route path={"/product/:slug"} element={<Products />} />
          </Routes>
      </div>
  );
}

export default App;
